import { SET_MY_INFO_DATA } from '../../common/constants/reduxConstants'

export const setMyInfoData = (data: any) => {
  return { type: SET_MY_INFO_DATA, data }
}
